export type {
  AddInvoiceToClaimProps,
  ClaimListItem,
} from "./AddInvoiceToClaim.types";

import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import type { AddInvoiceToClaimProps } from "./AddInvoiceToClaim.types";
import { AddInvoiceToClaimLoading } from "./AddInvoiceToClaim.loading";

export const AddInvoiceToClaimLoadable = lazy(
  () => import("./AddInvoiceToClaim")
);

export const AddInvoiceToClaim = (props: AddInvoiceToClaimProps) => {
  return (
    <ErrorBoundary
      fallback={<ErrorFallback />}
      onError={(error, componentStack) => {
        console.error("[AddInvoiceToClaim] Error caught by boundary:", error);
        console.error("[AddInvoiceToClaim] Component stack:", componentStack);
      }}
    >
      <Suspense fallback={<AddInvoiceToClaimLoading />}>
        <AddInvoiceToClaimLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
